export default {"src":"__ASTRO_ASSET_IMAGE__BBFz0u4P__","width":1080,"height":670,"format":"jpg"}